
import React from 'react';
import { FaChartLine } from 'react-icons/fa';
import { LineChart } from '../../../common/ReusableComponent/Chart';

const GasPriceChart = ({ top_10_invoices_based_on_total_amount = [] }) => {
  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];

  const hasData = top_10_invoices_based_on_total_amount.length > 0;
  const isSinglePoint = top_10_invoices_based_on_total_amount.length === 1;

  const data = hasData
    ? {
        labels: top_10_invoices_based_on_total_amount.map((item) => {
          const date = new Date(item.date);
          return monthNames[date.getMonth()];
        }),
        datasets: [
          {
            label: 'Invoices Based on Total Amount',
            data: top_10_invoices_based_on_total_amount.map((item) => item.invoice_total),
            fill: false,
            borderColor: '#20a0f1',
            tension: 0.1,
            pointBackgroundColor: '#FF5733',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: '#FF5733',
          },
        ],
      }
    : null;

  return (
    <div className="dashboard-chart-area">
      {hasData ? (
        isSinglePoint ? (
          <div style={{textAlign:'center', width:'100%', marginTop:'32px'}}>
            <div style={{fontSize:'2.2rem', fontWeight:700, color:'#20a0f1', marginBottom:'8px'}}>
              ₹{top_10_invoices_based_on_total_amount[0].invoice_total.toLocaleString()}
            </div>
            <div style={{fontSize:'1.1rem', color:'#23272f'}}>Highest Invoice (Jul)</div>
          </div>
        ) : (
          <LineChart
            labels={data.labels}
            datasets={data.datasets}
            title={null}
            legendPosition="top"
            theme="custom"
            width="100%"
            height="260px"
            noBorder
            noShadow
            options={{
              plugins: {
                legend: { labels: { font: { size: 14 } } },
                tooltip: {
                  callbacks: {
                    label: (context) => `₹ ${context.parsed.y.toLocaleString()}`
                  }
                }
              },
              scales: {
                x: {
                  title: {
                    display: true,
                    text: 'Month',
                    font: { size: 13, weight: 'bold' },
                    color: '#7a7a8c',
                  }
                },
                y: {
                  title: {
                    display: true,
                    text: 'Amount (₹)',
                    font: { size: 13, weight: 'bold' },
                    color: '#7a7a8c',
                  },
                  ticks: {
                    callback: (val) => `₹${val}`,
                  }
                }
              }
            }}
          />
        )
      ) : (
        <div className="no-data-message" style={{display:'flex', flexDirection:'column', alignItems:'center', marginTop:'40px'}}>
          <FaChartLine size={38} color="#e3e6ee" style={{marginBottom:'10px'}} />
          No data available for this period
        </div>
      )}
    </div>
  );
};

export default GasPriceChart;